export const config = {
  width: 640,
  height: 640,
  facingMode: "user",
};

export const dtConfig = {
  inputResolution: { width: config.width, height: config.height },
  scale: 0.8,
};
